"use strict";

exports.__esModule = true;
exports.downloadOptionPropType = exports["default"] = exports.ShieldIcon = exports.MidDot = exports.LockIcon = exports.LinkOut = exports.ButtonCta = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _elements = require("../glyphs/elements");

var _cta = _interopRequireDefault(require("../cta"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LockIcon = (0, _styledComponents["default"])(_elements.SecurityLock).withConfig({
  displayName: "download-links__LockIcon",
  componentId: "sc-84fr6m-0"
})(["margin-right:4px;width:18px;height:18px;fill:currentColor;vertical-align:text-bottom;"]);
exports.LockIcon = LockIcon;
var ShieldIcon = (0, _styledComponents["default"])(_elements.Shield).withConfig({
  displayName: "download-links__ShieldIcon",
  componentId: "sc-84fr6m-1"
})(["margin-right:4px;width:18px;height:18px;fill:currentColor;vertical-align:text-bottom;"]);
exports.ShieldIcon = ShieldIcon;
var LinkOut = (0, _styledComponents["default"])(_elements.NavLinkOutSimple).withConfig({
  displayName: "download-links__LinkOut",
  componentId: "sc-84fr6m-2"
})(["margin-left:6px;width:12px;height:12px;fill:currentColor;vertical-align:top;"]);
exports.LinkOut = LinkOut;
var ButtonCta = (0, _styledComponents["default"])(_cta["default"]).withConfig({
  displayName: "download-links__ButtonCta",
  componentId: "sc-84fr6m-3"
})(["display:inline-block;white-space:nowrap;"]);
exports.ButtonCta = ButtonCta;

var MidDot = _styledComponents["default"].span.withConfig({
  displayName: "download-links__MidDot",
  componentId: "sc-84fr6m-4"
})(["margin-left:8px;margin-right:8px;"]);

exports.MidDot = MidDot;
var optionIcon = {
  lock: /*#__PURE__*/_react["default"].createElement(LockIcon, null),
  shield: /*#__PURE__*/_react["default"].createElement(ShieldIcon, null)
};
var downloadOptionPropType = (0, _propTypes.shape)({
  /** if download option has external link */
  external: _propTypes.bool,

  /** download option icon can only be lock, shield or none */
  icon: (0, _propTypes.oneOf)(Object.keys(optionIcon)),

  /** id of option */
  id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired,

  /** onClick handler for download option, defaults to downloadAction */
  optionOnClick: _propTypes.func,

  /** download option text */
  text: _propTypes.string,

  /** version of download option */
  version: _propTypes.string
});
exports.downloadOptionPropType = downloadOptionPropType;
var propTypes = {
  /** Text to show when hiding the download options */
  alternateText: _propTypes.string,

  /** classificaton string */
  classification: _propTypes.string,

  /** OnClick handler for download and login links */
  downloadAction: _propTypes.func,

  /** Array of download option objects */
  downloadOptions: (0, _propTypes.arrayOf)(downloadOptionPropType),

  /**  Text for download options group */
  downloadText: _propTypes.string,

  /** result item type string */
  resource: _propTypes.string,

  /** Boolean to show/hide download options */
  showDownloadOptions: _propTypes.bool
};

var DownloadLinks = function DownloadLinks(_ref) {
  var alternateText = _ref.alternateText,
      resource = _ref.resource,
      classification = _ref.classification,
      downloadAction = _ref.downloadAction,
      downloadText = _ref.downloadText,
      downloadOptions = _ref.downloadOptions,
      showDownloadOptions = _ref.showDownloadOptions;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, null, showDownloadOptions && downloadOptions ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "flex-start",
    justifyContent: "flex-start"
  }, downloadText && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "body-grey",
    display: "flex",
    mr: 3,
    tag: "span"
  }, downloadText), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "flex-start",
    flexDirection: resource ? ["row"] : ["column", "row"],
    flexWrap: !resource ? "wrap" : "nowrap",
    justifyContent: "flex-start"
  }, (0, _ramda.map)(function (downloadOption) {
    if (downloadOption === void 0) {
      downloadOption = {};
    }

    var _downloadOption = downloadOption,
        id = _downloadOption.id,
        text = _downloadOption.text,
        version = _downloadOption.version,
        icon = _downloadOption.icon,
        _downloadOption$optio = _downloadOption.optionOnClick,
        optionOnClick = _downloadOption$optio === void 0 ? downloadAction : _downloadOption$optio;
    return /*#__PURE__*/_react["default"].createElement(ButtonCta, {
      key: id,
      fontSize: resource ? 2 : 1,
      fontWeight: resource ? 1 : 2,
      id: id,
      letterSpacing: "0.5px",
      mb: 0,
      mr: resource ? [3] : [0, classification ? 0 : 3],
      onClick: function onClick(event) {
        return optionOnClick({
          data: downloadOption,
          event: event
        });
      },
      version: "link"
    }, optionIcon[icon], text, version && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
      color: "body-grey",
      display: "inline-block",
      fontWeight: 1,
      letterSpacing: "0.5px",
      ml: "4px",
      tag: "span"
    }, "(" + version + ")"), downloadOption.external ? /*#__PURE__*/_react["default"].createElement(LinkOut, null) : null);
  }, downloadOptions)), classification && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "body-grey"
  }, /*#__PURE__*/_react["default"].createElement(MidDot, null, "\xB7"), classification)) : /*#__PURE__*/_react["default"].createElement(ButtonCta, {
    fontSize: 1,
    fontWeight: 2,
    onClick: downloadOptions ? function (event) {
      return downloadAction({
        data: (0, _ramda.head)(downloadOptions),
        event: event
      });
    } : downloadAction,
    version: "link"
  }, /*#__PURE__*/_react["default"].createElement(LockIcon, null), alternateText));
};

DownloadLinks.propTypes = propTypes;
DownloadLinks.displayName = "Modules.DownloadLinks";
var _default = DownloadLinks;
exports["default"] = _default;